export default "__VITE_ASSET__wlfhzSqq__"